import { defineComponent as _defineComponent } from 'vue'
import { useInvites } from '@/store/invites';
import { useUserspace } from '@/store/userspace';
import { DataInstance, InviteLinks } from '@busy-human/opt-library';
import { computed, ref } from 'vue'
import QrCode from '../QrCode.vue';

type Emits = {
    (e: 'progress'): void
    (e: 'back'):void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'qr-setup',
  emits: ["progress", "back"],
  setup(__props, { expose, emit }: { emit: ({
    (e: 'progress'): void
    (e: 'back'):void
}), expose: any, slots: any, attrs: any }) {
  expose();



const userspace = useUserspace();
const invites = useInvites();
const user = computed(() => userspace.user);

const allLinks = computed(() => invites.links);
const inviteLink = computed(() => {
    if(user.value.standardInviteLink) {
        const linkInstance: DataInstance<InviteLinks.Model> | undefined = allLinks.value.find(link => link.$id === user.value.standardInviteLink);
        if(!linkInstance) return undefined;

        return `${window.location.protocol}//${window.location.host}/#/invite/${linkInstance.link}`
    } else return undefined;
})
const moveBack = () =>{
    emit('back')
}

const __returned__ = { emit, userspace, invites, user, allLinks, inviteLink, moveBack, useInvites, useUserspace, DataInstance, InviteLinks, computed, ref, QrCode }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})